import styled, { css } from 'styled-components'

import { device } from '~/styles/utils'

import type { TextAlign } from '~/styles/theme'

export const Wrapper = styled.p<{
  $loading: boolean
  $textAlign: TextAlign
}>`
  margin: 0;
  font-size: 14px;
  padding-right: 8px;
  ${({ $textAlign }) => $textAlign && `text-align: ${$textAlign}`};

  ${({ $loading }) =>
    $loading
      ? css`
          display: none;
        `
      : null};

  @media ${device('notMobile')} {
    font-size: 16px;
  }
`
